// extracted by mini-css-extract-plugin
export default {"paragraph":"_1thMG9jpcyULDGc0qr-YZR"};